var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDbnLogoOuter = function SvgDbnLogoOuter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 520,
    viewBox: "0 0 520 520",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.459 0L260.001 0H259.541C116.126 0.248949 0.38666 117.622 -0.000976562 259.286V260.713C0.387071 402.522 116.372 518.269 259.998 520C403.865 520 519.998 402.133 519.998 260C519.998 116.286 404.113 0.247527 260.459 0ZM65.8648 260C65.8648 367.466 152.531 452.4 259.998 454.133C367.465 454.133 454.132 367.466 454.132 260C454.132 152.533 367.465 65.8663 259.998 65.8663C152.531 65.8663 65.8648 152.533 65.8648 260Z",
    fill: "inherit"
  })));
};
export default SvgDbnLogoOuter;